<script>
import { defineAsyncComponent } from "vue";
import { Head, Link } from '@inertiajs/vue3';

export default {
    components: {
        BreezeLayout: defineAsyncComponent(() => import('@/Layouts/Authenticated.vue')),
        Head,
        Link
    },
    props: {
        user: Object,
        profile: Object
    }
}
</script>

<template>
    <Head title="Profile"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('profile.index')">My profile</Link>
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-gray-100">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div class="mt-10 sm:mt-0">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1 flex justify-between flex-col">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Show Profile</h3>
                                        <p class="mt-1 text-sm text-gray-600">
                                            This is your data.
                                        </p>
                                    </div>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="shadow overflow-hidden sm:rounded-md">
                                        <div class="px-4 py-5 bg-white sm:p-6 relative">
                                            <Link class="absolute end-5 top-3 p-1 text-xs" :href="route('profile.edit', {user: user.id})" tabindex="-1">
                                                edit
                                            </Link>

                                            <table class="table-auto w-3/4">
                                                <caption class="hidden">Your profile</caption>
                                                <tr>
                                                    <th class="text-left py-2">Fields</th>
                                                    <th class="text-left py-2">Values</th>
                                                </tr>
                                                <tr>
                                                    <td class="py-2">Username</td>
                                                    <td class="py-2">{{ user.name }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="py-2">Email</td>
                                                    <td class="py-2">{{ user.email }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="py-2">Account Holder Code</td>
                                                    <td class="py-2">{{ user.profile.account_holder_code }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeLayout>
</template>